import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';

const features = [
  {
    symbol: '✦',
    title: 'Expert & Trained Stylists',
    desc: 'Our team of certified professionals brings years of experience and ongoing training in the latest hair and beauty techniques.',
  },
  {
    symbol: '✦',
    title: 'Premium Hair Products Only',
    desc: 'We exclusively use top-tier, salon-grade products that nourish, protect, and enhance your hair and skin.',
  },
  {
    symbol: '✦',
    title: 'Relaxing Spa Environment',
    desc: 'Step into a haven of calm. Our thoughtfully designed space is crafted to help you fully unwind and feel pampered.',
  },
  {
    symbol: '✦',
    title: '4.9 Stars — Loved by Abuja',
    desc: 'With 132+ glowing Google reviews, our clients speak for us. Consistently rated Abuja\'s favourite premium salon.',
  },
];

/* Decorative SVG art — woman silhouette with floral elements */
const SalonArt = () => (
  <svg viewBox="0 0 360 480" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full max-h-[480px]">
    {/* Background circle */}
    <circle cx="180" cy="260" r="200" fill="#F5E6D3" opacity="0.3" />
    <circle cx="180" cy="260" r="160" fill="#F5E6D3" opacity="0.2" />

    {/* Woman silhouette */}
    <ellipse cx="180" cy="130" rx="40" ry="45" fill="#6B2737" opacity="0.85" />
    {/* Hair flowing */}
    <path d="M145 110C140 80 150 50 180 45C210 50 220 80 215 110" fill="#1A1A1A" opacity="0.9" />
    <path d="M140 130C130 120 128 100 135 85C140 78 148 72 155 80C150 95 148 120 150 140" fill="#1A1A1A" opacity="0.85" />
    <path d="M220 130C230 120 232 100 225 85C220 78 212 72 205 80C210 95 212 120 210 140" fill="#1A1A1A" opacity="0.85" />
    {/* Long hair braids */}
    <path d="M148 140C140 160 138 200 145 240C148 260 150 280 148 300" stroke="#1A1A1A" strokeWidth="8" strokeLinecap="round" opacity="0.7" />
    <path d="M212 140C220 160 222 200 215 240C212 260 210 280 212 300" stroke="#1A1A1A" strokeWidth="8" strokeLinecap="round" opacity="0.7" />
    <path d="M160 155C158 180 160 220 165 260C167 280 166 310 162 330" stroke="#1A1A1A" strokeWidth="6" strokeLinecap="round" opacity="0.6" />
    <path d="M200 155C202 180 200 220 195 260C193 280 194 310 198 330" stroke="#1A1A1A" strokeWidth="6" strokeLinecap="round" opacity="0.6" />
    {/* Braid details */}
    <path d="M143 160C148 165 153 162 148 168C143 173 150 176 145 182" stroke="#C9956C" strokeWidth="2" strokeLinecap="round" opacity="0.8" />
    <path d="M217 160C212 165 207 162 212 168C217 173 210 176 215 182" stroke="#C9956C" strokeWidth="2" strokeLinecap="round" opacity="0.8" />

    {/* Shoulders / body */}
    <path d="M140 175C130 185 120 200 118 230C116 260 120 300 125 340L235 340C240 300 244 260 242 230C240 200 230 185 220 175L140 175Z" fill="#6B2737" opacity="0.6" />

    {/* Decorative flowers - top left */}
    <circle cx="60" cy="80" r="18" fill="#C9956C" opacity="0.4" />
    <circle cx="60" cy="56" r="10" fill="#C9956C" opacity="0.3" />
    <circle cx="80" cy="72" r="10" fill="#C9956C" opacity="0.3" />
    <circle cx="76" cy="96" r="10" fill="#C9956C" opacity="0.3" />
    <circle cx="50" cy="96" r="10" fill="#C9956C" opacity="0.3" />
    <circle cx="44" cy="72" r="10" fill="#C9956C" opacity="0.3" />
    <circle cx="60" cy="80" r="8" fill="#F5E6D3" opacity="0.9" />
    <circle cx="60" cy="80" r="4" fill="#C9956C" />

    {/* Decorative flowers - top right */}
    <circle cx="300" cy="100" r="15" fill="#C9956C" opacity="0.35" />
    <circle cx="300" cy="80" r="9" fill="#C9956C" opacity="0.25" />
    <circle cx="316" cy="91" r="9" fill="#C9956C" opacity="0.25" />
    <circle cx="313" cy="111" r="9" fill="#C9956C" opacity="0.25" />
    <circle cx="297" cy="116" r="9" fill="#C9956C" opacity="0.25" />
    <circle cx="284" cy="111" r="9" fill="#C9956C" opacity="0.25" />
    <circle cx="300" cy="100" r="6" fill="#F5E6D3" opacity="0.9" />

    {/* Sparkles */}
    <path d="M280 50L282 60L292 62L282 64L280 74L278 64L268 62L278 60L280 50Z" fill="#C9956C" opacity="0.7" />
    <path d="M80 200L81.5 207L89 208.5L81.5 210L80 217L78.5 210L71 208.5L78.5 207L80 200Z" fill="#C9956C" opacity="0.5" />
    <path d="M310 200L311 205L316 206L311 207L310 212L309 207L304 206L309 205L310 200Z" fill="#F5E6D3" opacity="0.6" />
    <path d="M50 300L51.5 307L59 308.5L51.5 310L50 317L48.5 310L41 308.5L48.5 307L50 300Z" fill="#C9956C" opacity="0.4" />

    {/* Mirror / vanity circle */}
    <circle cx="180" cy="380" r="60" fill="none" stroke="#C9956C" strokeWidth="2" opacity="0.3" />
    <circle cx="180" cy="380" r="50" fill="none" stroke="#C9956C" strokeWidth="1" opacity="0.2" strokeDasharray="4 4" />

    {/* Stem */}
    <line x1="180" y1="330" x2="180" y2="350" stroke="#C9956C" strokeWidth="2" opacity="0.4" />

    {/* Rose gold accent ring */}
    <circle cx="180" cy="130" r="52" fill="none" stroke="#C9956C" strokeWidth="1" opacity="0.3" strokeDasharray="5 5" />

    {/* Bottom flowers */}
    <circle cx="100" cy="410" r="14" fill="#C9956C" opacity="0.25" />
    <circle cx="260" cy="420" r="12" fill="#C9956C" opacity="0.2" />
    <circle cx="320" cy="380" r="10" fill="#F5E6D3" opacity="0.3" />
    <circle cx="40" cy="370" r="11" fill="#F5E6D3" opacity="0.25" />
  </svg>
);

export default function WhyUs() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '-100px' });

  return (
    <section id="about" className="py-24 lg:py-32 relative overflow-hidden"
      style={{ background: 'linear-gradient(135deg, #FDF8F5 0%, #F5E6D3 100%)' }}>

      {/* Background decorative elements */}
      <div className="absolute top-0 right-0 w-64 h-64 rounded-full opacity-20"
        style={{ background: 'radial-gradient(circle, #C9956C, transparent 70%)' }} />
      <div className="absolute bottom-0 left-0 w-48 h-48 rounded-full opacity-15"
        style={{ background: 'radial-gradient(circle, #6B2737, transparent 70%)' }} />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div ref={ref} className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">

          {/* Left — decorative art */}
          <motion.div
            initial={{ opacity: 0, x: -60 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
            className="flex items-center justify-center lg:justify-end"
          >
            <div className="relative w-full max-w-sm">
              {/* Glow behind art */}
              <div className="absolute inset-0 rounded-full opacity-30 blur-3xl"
                style={{ background: 'radial-gradient(circle, #C9956C, transparent 60%)' }} />

              {/* Art frame */}
              <div className="relative rounded-3xl overflow-hidden border border-roseGold/20 bg-white/30 backdrop-blur-sm p-4 shadow-2xl shadow-roseGold/10">
                <SalonArt />
              </div>

              {/* Floating badge */}
              <div className="absolute -bottom-4 -right-4 bg-white rounded-2xl px-5 py-3 shadow-xl shadow-roseGold/20 border border-champagne">
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 rounded-full bg-gradient-to-br from-roseGold to-burgundy flex items-center justify-center text-white text-xs font-bold font-playfair">
                    ★
                  </div>
                  <div>
                    <div className="font-playfair font-bold text-dark text-sm">4.9 / 5.0</div>
                    <div className="font-inter text-charcoal/60 text-xs">132 Reviews</div>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Right — content */}
          <div>
            <motion.p
              initial={{ opacity: 0, y: 10 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5 }}
              className="font-inter text-roseGold text-xs font-semibold tracking-[0.3em] uppercase mb-3"
            >
              Why Choose Us
            </motion.p>
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: 0.1 }}
              className="font-playfair text-4xl md:text-5xl font-bold text-dark mb-4 leading-tight"
            >
              The Lamisking
              <br />
              <span className="text-burgundy italic">Experience</span>
            </motion.h2>
            <motion.div
              initial={{ scaleX: 0 }}
              animate={inView ? { scaleX: 1 } : {}}
              transition={{ duration: 0.7, delay: 0.2 }}
              className="w-16 h-0.5 bg-gradient-to-r from-roseGold to-burgundy mb-6"
              style={{ transformOrigin: 'left' }}
            />
            <motion.p
              initial={{ opacity: 0 }}
              animate={inView ? { opacity: 1 } : {}}
              transition={{ duration: 0.6, delay: 0.25 }}
              className="font-inter text-charcoal/70 text-base leading-relaxed mb-10 max-w-lg"
            >
              At Lamisking, we believe beauty is more than skin deep. Every visit is a ritual —
              a moment to reconnect with yourself in an environment designed for luxury.
            </motion.p>

            {/* Feature list */}
            <div className="space-y-6">
              {features.map((feature, i) => (
                <motion.div
                  key={feature.title}
                  initial={{ opacity: 0, x: 40 }}
                  animate={inView ? { opacity: 1, x: 0 } : {}}
                  transition={{ duration: 0.6, delay: 0.3 + i * 0.12, ease: [0.16, 1, 0.3, 1] }}
                  className="flex items-start gap-4 group"
                >
                  {/* Icon */}
                  <div className="flex-shrink-0 w-10 h-10 rounded-xl bg-white shadow-md shadow-roseGold/10 flex items-center justify-center text-roseGold font-playfair font-bold text-base group-hover:bg-roseGold group-hover:text-white transition-all duration-300 border border-champagne">
                    {feature.symbol}
                  </div>
                  <div>
                    <h3 className="font-playfair font-semibold text-dark text-base mb-1">
                      {feature.title}
                    </h3>
                    <p className="font-inter text-charcoal/65 text-sm leading-relaxed">
                      {feature.desc}
                    </p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
